<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div class="mb-6">
          <div class="label-input">Section Background</div>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.textColor"
                    @change="e => (fields.textColor = e.target.value)"
                  />
                  <v-text-field v-model="fields.textColor" label="Text color" :hide-details="true" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['background-section'].color"
                    @change="e => (fields['background-section'].color = e.target.value)"
                  />
                  <v-text-field v-model="fields['background-section'].color" label="Background" :hide-details="true" />
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" cols="12">
                <v-checkbox v-model="fields.padding.top" label="Top padding" :hide-details="true" />
              </v-col>
              <v-col md="6" cols="12">
                <v-checkbox v-model="fields.padding.bottom" label="Bottom padding" :hide-details="true" />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-6">
          <label class="label-input">Container content</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <v-checkbox v-model="fields['container-content'].showStyle" label="Show style" />
              </v-col>
              <v-col cols="12" md="8">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['container-content'].background"
                    @change="e => (fields['container-content'].background = e.target.value)"
                  />
                  <v-text-field v-model="fields['container-content'].background" label="Container background" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-6">
          <label class="label-input">Title and description</label>
          <div class="group-item">
            <v-checkbox
              v-model="fields.titleCard.show"
              label="Show title block"
              class="mb-2 mt-0"
              :hide-details="true"
            />
            <ckeditor :editor="editor" v-model="fields.titleCard.content" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Button</label>
          <div class="group-item">
            <v-checkbox v-model="fields.btnCard.show" label="Show button" class="mt-0 mb-2" :hide-details="true" />
            <v-row v-if="fields.btnCard.show">
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.btnCard.text" label="Button text" />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.btnCard.url" label="Button URL" />
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.btnCard.background"
                    @change="e => (fields.btnCard.background = e.target.value)"
                  />
                  <v-text-field v-model="fields.btnCard.background" label="Button background" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.btnCard.color"
                    @change="e => (fields.btnCard.color = e.target.value)"
                  />
                  <v-text-field v-model="fields.btnCard.color" label="Button text color" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer />
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';

export default {
  name: 'TextWithButtonSectionEditor',
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Text with Button',
        enableAnchor: false,
        textColor: '#000000',
        padding: { top: true, bottom: true },
        'background-section': { color: '#ffffff' },
        'container-content': { showStyle: false, background: '#ffffff' },
        titleCard: { show: true, content: '' },
        btnCard: {
          show: true,
          text: '',
          url: '#',
          background: '#214a88',
          color: '#ffffff',
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
    if (!this.fields.padding) {
      this.fields.padding = { top: true, bottom: true };
    }
    if (!this.fields['background-section']) {
      this.fields['background-section'] = { color: '#ffffff' };
    }
    if (!this.fields['container-content']) {
      this.fields['container-content'] = { showStyle: false, background: '#ffffff' };
    }
    if (!this.fields.titleCard) {
      this.fields.titleCard = { show: true, content: '' };
    }
    if (!this.fields.btnCard) {
      this.fields.btnCard = {
        show: true,
        text: '',
        url: '#',
        background: '#214a88',
        color: '#ffffff',
      };
    }
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionTextWithButton(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.ck-editor__editable_inline {
  min-height: 200px;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
</style>
